module.exports = __webpack_public_path__ + "b221801736aeed825c30b38fb628c7f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/overview/tooieIconBack.png
// module id = 485
// module chunks = 0